import React, { useEffect } from 'react';
import { Provider } from 'mobx-react';
import PlusConfigProvider from '@fle-ui/plus-config-provider';
import Router from '@/router';
import * as stores from '@/store/index';
import './App.less';
import '@/views/Main/index.less';
import { parse } from 'qs';
import Store from '@/config/storage';
import { CommonStore } from '@/store/index';
import commonStore from '@/store/commonStore';
import { getSiteShareConfig } from '@/views/Main/store';
import Cookies from 'js-cookie';
import { App as AntdApp } from 'antd';

const App = (props: any) => {
  // const siteId = window.fleLocation.pathname.split("/")[1];

  const siteId = Cookies.get('siteId');

  if (siteId) {
    sessionStorage.setItem('siteId', siteId);
  }
  useEffect(() => {
    const store = new Store();
    const params: any = parse(window.fleLocation.search, {
      ignoreQueryPrefix: true,
    });
    if (params.token) {
      store.setItem('token', params.token);
    }
    if (params.from) {
      store.setItem('from', params.from);
    } else {
      window.localStorage.removeItem('from');
    }
  }, []);

  /* 判断营销号还是数字卡券权限 */
  useEffect(() => {
    const getSiteInfo = async (siteId: any) => {
      const { data, success } = (await getSiteShareConfig(siteId)) as any;
      if (success) {
        const { siteName, customerName, homepageDecorationId, adminPageLogo, app, cityId, provinceId, id } = data;
        CommonStore.setAppId(app);
        CommonStore.setHomepageDecorationId(homepageDecorationId);
        commonStore.setCategoryId(app);
        commonStore.setProvinceId(provinceId);
        commonStore.setCityId(cityId);
        commonStore.setSiteId(id);
        // 通过遍历获取默认选中标签
      }
    };
    getSiteInfo(siteId);
  }, [siteId]);

  return (
    <Provider {...stores} siteId={siteId}>
      <PlusConfigProvider>
        <Router />
      </PlusConfigProvider>
    </Provider>
  );
};

export default App;
